import React from "react";
import Header from "./Header";
import AgreementsHub from "../extension/AgreementsHub";

export default function LayoutAgreementsHub() {
  return (
    <>
      <Header />
      <AgreementsHub />
    </>
  );
}
